import React, { useState } from 'react';
import { Input } from './ui/input';
import { UserSearch, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const MemberPicker = ({ authHeaders, onPick, selected, testId }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const search = async (term) => {
    setQuery(term);
    onPick(null);
    if (term.trim().length < 2) { setResults([]); return; }
    setSearching(true);
    try {
      const params = new URLSearchParams({ search: term.trim(), limit: '8' });
      const res = await fetch(`${API_URL}/api/members/directory/admin?${params.toString()}`, { headers: authHeaders });
      const data = await res.json();
      if (res.ok) setResults(Array.isArray(data) ? data : (data.members || []));
    } catch (e) {
      setResults([]);
    } finally {
      setSearching(false);
    }
  };

  return (
    <div className="relative flex-1 max-w-xs">
      <UserSearch size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-stone-400" />
      <Input
        value={query}
        onChange={(e) => search(e.target.value)}
        placeholder="Search member by name or email..."
        className="pl-8 h-9 text-xs"
        data-testid={testId}
      />
      {results.length > 0 && !selected && (
        <div className="absolute z-20 top-full left-0 w-full bg-white border border-stone-200 rounded shadow-lg mt-1 max-h-48 overflow-y-auto">
          {results.map((m) => (
            <button
              key={m.id}
              className="w-full text-left px-3 py-1.5 text-xs hover:bg-stone-50 border-b border-stone-100 last:border-0"
              onClick={() => { onPick(m); setResults([]); setQuery(`${m.first_name} ${m.last_name}`); }}
              data-testid={`${testId}-option-${m.id}`}
            >
              {m.first_name} {m.last_name} <span className="text-stone-400">— {m.email}</span>
            </button>
          ))}
        </div>
      )}
      {searching && <Loader2 size={13} className="absolute right-2.5 top-1/2 -translate-y-1/2 animate-spin text-stone-400" />}
    </div>
  );
};
